import React, {useEffect, useState} from 'react'
import "./portofolio.css"
import IMG4 from '../../loader_4.gif'
import IMG1 from '../../NoteImg1.png'
const data =[
  {
    id:1,
    image: IMG1,
    title: 'Note App',
    github: 'https://github.com/Taxiarchoula/',
    demo: "https://taxiarchoula.github.io/note-app/"
  },
  {
    id:2,
    image: IMG4,
    title: 'Coming soon',
    github: 'https://github.com/Taxiarchoula/',
    demo: 'https://github.com/Taxiarchoula'
  },
  {
    id:2,
    image: IMG4,
    title: 'Coming soon',
    github: 'https://github.com/Taxiarchoula/',
    demo: 'https://github.com/Taxiarchoula'  
  }
]
const Portofolio = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sectionElement = document.getElementById('portofolio'); 

      if (sectionElement) {
        const { top, bottom } = sectionElement.getBoundingClientRect();
        const isVisible = top < window.innerHeight && bottom >= 0;

        setIsVisible(isVisible);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <section id='portofolio' className={`section ${isVisible ? 'fade-in' : ''}`}>
      <h5>My Recend Work</h5>
      <h2>Portfolio</h2>
      <div className='container portofolio__container'>
        {
          data.map(({id,image,title,github,demo}) => {
            return (
              <article className='portofolio__item'>
          <div className='portofolio__item-image'>
            <img src={image} alt={title}/>
          </div>
          <h3>{title}</h3>
          <div className='portofolio__item-cta'>
            <a href= {github} className='btn' target='_blank'>Github</a>
          <a href={demo} className='btn btn-primary'  target='_blank'>Live Demo</a>
          </div>
        </article>
            )
          })
        }
        </div>
    </section>
  )
}

export default Portofolio
